import { type Action } from 'redux';

import { COMPANY_FETCHED, COMPANY_UPDATED } from 'constants/actions';
import { type Company } from 'data/v1/data-contracts';

const initialState = {} as Company;

export interface SetCompanyAction
  extends Action<typeof COMPANY_FETCHED | typeof COMPANY_UPDATED> {
  company: Company;
}

export default function company(
  // eslint-disable-next-line default-param-last
  state = initialState,
  action: SetCompanyAction,
) {
  switch (action.type) {
    case COMPANY_FETCHED:
    case COMPANY_UPDATED:
      return { ...action.company };
    default:
      return state;
  }
}
